var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRadio20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 19,
  x: 0.5,
  y: 0.5,
  fill: "#fff",
  stroke: "#DDD",
  rx: 9.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 9,
  height: 9,
  x: 5.5,
  y: 5.5,
  fill: "#EAEAEA",
  rx: 4.5
})));
export default SvgIconRadio20;